export default __webpack_public_path__ + "static/media/illustration-laptop-mobile.fe1ec0f0.svg";